import { useContext } from "react";
import { ThemeProviderContext } from "@/components/ui/theme-provider";

export type Theme = "light" | "dark" | "dark-premium";

export function useTheme() {
  const context = useContext(ThemeProviderContext);

  if (context === undefined) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }

  return {
    ...context,
    isDarkMode: context.theme === "dark" || context.theme === "dark-premium",
    isPremiumDark: context.theme === "dark-premium",
    isLight: context.theme === "light",
  };
}
